define('plugin/classes/step/ClassesPluginProviderStep',['require','lib/controller/booking/BaseStep','controller/step/ProviderStep','collection/ProviderCollection','view/controller/booking/provider/ProviderStepView'],function (require) {

    var BaseStep = require('lib/controller/booking/BaseStep');
    var ProviderStep = require('controller/step/ProviderStep');
    var ProviderCollection = require('collection/ProviderCollection');
    var ProviderStepView = require('view/controller/booking/provider/ProviderStepView');

    return ProviderStep.extend({

        _step: 'provider',
        _providerCollection: null,
        _dataKey: null,
        _timeValidateModel: null,
        _prevValidatedData: {},

        /**
         * Inits instance, collection, subscribe to events
         */
        initialize: function() {
            BaseStep.prototype.initialize.call(this);

            this._providerCollection = new ProviderCollection();
            this.updateList();
            this._providerCollection.setComparator(_.bind(this.providerComparator, this));

            this.listenTo(this._providerCollection, 'sync', this.onDataFetch);

            // perform filter performers after all data fetched from server (like services, locations, etc.)
            this.listenTo(this._stepManager, 'step:fetch', this.performCollectionFilters);
        },

        /**
         * Triggers init event
         */
        triggerInit: function () {
            this.triggerStepEvent('init', [this, this._providerCollection]);
        },

        /**
         * Update provider list
         */
        updateList: function () {
            var data = {
                'date': this._bookingModel.get('start_date'),
                'time': this._bookingModel.get('start_time'),
                'location': this._bookingModel.get('location_id'),
                'category': this._bookingModel.get('category_id'),
                'service': this._bookingModel.get('service_id'),
                'provider': this._bookingModel.get('provider_id'),
                'count': this._bookingModel.get('count'),
                'wl': this._bookingModel.get('wl')
            };

            var dataKey = _.values(data).join();

            if (dataKey !== this._dataKey) {
                this._providerCollection.reset([]);
                this._providerCollection._once_synced = false;
                this._providerCollection.getDataCollection().reset([]);

                this._providerCollection.fetch({
                    data: data
                });

                this._dataKey = dataKey;
            }
        },

        /**
         * Returns true if provider is selected
         *
         * @return Boolean
         */
        isValid: function () {
            this.updateList();
            this.performCollectionFilters();
            this._autoSelectItem();

            if (this._bookingModel.get('provider_id')) {
                return true;
            }
            return false;
        },

        /**
         * Returns step view
         *
         * @return ProviderStepView
         */
        getView: function () {
            return new ProviderStepView({
                collection: this._providerCollection,
                model: this._timeValidateModel
            });
        },

        /**
         * Calls when collection fetched from server
         */
        onDataFetch: function () {
            this.triggerStepEvent('fetch');

            this.done();
        },

        /**
         * Auto select service if collection contains single service
         *
         * @private
         */
        _autoSelectItem: function () {
            var service = this._bookingModel.get('service');
            if (service && service.class_id) {
                this._bookingModel.set('provider_id', Object.keys(service.unit_map).shift());
                this.setIsSkipped(true);

                return;
            }
            if (this._providerCollection.length === 0) {
                return;
            }

            return ProviderStep.prototype._autoSelectItem.apply(this);
        }

    });

});
